import type { RangeResult } from "schemas/generated/analyticsRead";

export function generateFakeChartDataRangeResult(): RangeResult {
  return {
    urlPath: "some_domain.com",
    metadata: {
      elementId: null,
      title: "Some random title",
      url: "https://www.google.com/some-page",
    },
    rangeId: "f13ffb7f-ea60-474c-a3dd-669070b5f8a2",
    metrics: {
      views: Array.from({ length: 168 }, () => {
        return Math.floor(Math.random() * 1500 + 200);
      }),
      unique_sessions: Array.from({ length: 168 }, () => {
        return Math.floor(Math.random() * 600 + 50);
      }),
      conversions: Array.from({ length: 168 }, () => {
        return Math.floor(Math.random() * 35 + 1);
      }),
      revenue: Array.from({ length: 168 }, () => {
        return Number((Math.random() * 2500 + 100).toFixed(2));
      }),
      conversion_rates: Array.from({ length: 168 }, () => {
        return Number((Math.random() * 8 + 1).toFixed(2));
      }),
      average_order_value: Array.from({ length: 168 }, () => {
        return Number((Math.random() * 100 + 25).toFixed(2));
      }),
      revenue_per_session: Array.from({ length: 168 }, () => {
        return Number((Math.random() * 5 + 0.5).toFixed(2));
      }),
    },
  };
}
